import { render, staticRenderFns } from "./article-true-cost-table.vue?vue&type=template&id=367bac94&scoped=true&"
import script from "./article-true-cost-table.vue?vue&type=script&lang=ts&"
export * from "./article-true-cost-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367bac94",
  null
  
)

export default component.exports